var context,
    newCanvas,
    objLLegenda = null,
    ldpercent_img = 0,
    matriuCapesLL = {
        layers: [],
        n_layers: [],
        id_layers: [],
        t_layers: [],
        c_layers: [],
        e_layers: [],
        extent: {}
    };

function comportamentCaptura(inicial, titol, text_progress) {
    jQuery('#dialog_captura').find('.desc_img').text(window.lang.translate("Desar mapa"));

    switch (inicial) {
        case 0:
            ldpercent_img = 0;
            jQuery('.bt_desc_img').hide();
            jQuery('#bt_desc_ll').hide();
            jQuery('#div_captura').hide();
            jQuery('#progress_bar_carrega_img').show();
            jQuery('#dialog_captura').modal('show');
            jQuery('#dialog_captura_title').text(window.lang.translate(titol));
            jQuery('#div_msg_export').text(window.lang.translate(text_progress));
            uploadprogress_img();
            break;
        case 1: 
            jQuery('#progress_bar_carrega_img').hide();
            jQuery('.bt_desc_img').show();
            break;
        case 2:
            jQuery('#progress_bar_carrega_img').hide();
            jQuery('#dialog_captura').modal('hide');
            $.publish('errorCaptura', {titol: titol, text_progress: text_progress});
            break;
        case 3:
            jQuery('#progress_bar_carrega_img').hide();
            break;
        case 4: 
            jQuery('#progress_bar_carrega_img').hide();
            jQuery('.bt_desc_img').hide();
            jQuery('#bt_desc_ll').hide();
            jQuery('#div_captura').hide();
            jQuery('#dialog_captura').modal('show');
            jQuery('#dialog_captura').find('.desc_img').text('Anar');
            jQuery('#dialog_captura_title').text(window.lang.translate(titol));
            jQuery('#div_msg_export').html(window.lang.translate(text_progress));
            jQuery('#dialog_captura').find('.desc_img').on('click',function(){
                jQuery('#dialog_captura').modal('hide');
            });
            break;
    }
}

function uploadprogress_img() {
    ldpercent_img += 10;
    if (ldpercent_img > 100) {
        ldpercent_img = 100;
    }
    jQuery('#prg_bar_img').css('width', ldpercent_img + "%");
    if (ldpercent_img < 100) {
        setTimeout("uploadprogress_img()", 1500);
    }
}

function errorCaptura() {
    comportamentCaptura(2);
}

function capturaPantalla(tipus, mapConfig) {

    var dfd = $.Deferred();

    if (estatMapa3D) {
        disparaEventMapa = false;
        mapaEstatNOPublicacio = false;
    }
    ActDesPrintMode(true);
    var titol = "";
    var text_progress = "";
    switch (tipus) {
        case CAPTURA_MAPA:
            titol = "Capturar la vista del mapa";
            text_progress = "Es genera una impressió de pantalla del que mostra el mapa en el moment de clicar el botó.";
            break;
        case CAPTURA_MAPA_GEOPACKAGE:
            titol = "Descarrega les capes vectorials en format GeoPackage";
            text_progress = "Es genera un arxiu GeoPackage (base de dades) que conté només les capes vectorials del mapa i els seus atributs.";
            break;
        case CAPTURA_MAPA_GEOTIFF:
            titol = "Descarrega el mapa en format GeoTIFF";
            text_progress = "Es genera un arxiu TIF que conté coordenades -longitud i latitud -. Llegible per aplicacions de tractament d’imatge o SIG.";
            break;
        case CAPTURA_INFORME:
            titol = "Imprimir la vista del mapa";
            text_progress = "Es genera una vista prèvia que permet imprimir el que es visualitza a pantalla dins un full A4.";
            break;
        case CAPTURA_GALERIA:
            titol = "";
            text_progress = "";
            break;
        case CAPTURA_GEOPDF:
            titol = "Descarrega mapa en format GeoPDF";
            text_progress = "Es genera un arxiu PDF que conté capes i coordenades - longitud i latitud -.Llegible per aplicacions com Adobe Acrobat, Adobe Reader i altres.";
            break;
    }

    if("" !== titol){
    
        comportamentCaptura(0, titol, text_progress);
    
    }
    
    setTimeout(function () {

        generaCaptura(tipus, null, null, 2, mapConfig).then(function(urlIMG){
            dfd.resolve(urlIMG);
        }, function(err) {
            dfd.reject(err);
        });

    }, 500);

    return dfd.promise();
}

function createUrlIMG(uuid){
    return paramUrl.urlgetMapImage + "&uuid=" + uuid;
}

function descarregaCaptura(urlIMG, name){
    comportamentCaptura(1);
    var $desc_img = jQuery('#dialog_captura').find('.desc_img');
    $desc_img.prop('href', urlIMG);
    $desc_img.prop('download', name);
}

function generaCaptura(_tipusCaptura, w, h, factor, mapConfig) {
    var dfd = $.Deferred();

    map.setView([map.getCenter().lat, map.getCenter().lng], map.getZoom());
    if ((!w) || (w == null)) {
        var d = map.getSize();
        w = d.x;
        h = d.y;
    }

    switch (_tipusCaptura) {
        case CAPTURA_MAPA:
            captureMap(w, h).then(function(results){
                var urlIMG = "";
                if (results.status == "OK") {
                    urlIMG = createUrlIMG(results.UUID) + "&request=getCaptura";
                    descarregaCaptura(urlIMG, 'mapa_captura.png');
                } else {
                    errorCaptura();
                }
                dfd.resolve(urlIMG);
            }, function(err) {
                dfd.reject(err);
            });
            break;
        case CAPTURA_MAPA_GEOPACKAGE:
            captureGEOPackage(mapConfig).then(function(url){
                dfd.resolve(url);
            }, function(err) {
                dfd.reject(err);
            });
            break;
        case CAPTURA_MAPA_GEOTIFF:
            captureMap(w, h).then(function(results){
                var data = calculaWF();
                var urlIMG = "";
                if (results.status == "OK") {
                    urlIMG = createUrlIMG(results.UUID) + "&request=getCapturaGeoTiff";
                    urlIMG += "&resW=" + data.resW +
                        "&resH=" + data.resH +
                        "&x=" + data.x +
                        "&y=" + data.y +
                        "&x1=" + data.x1 +
                        "&y1=" + data.y1 +
                        "&resW4326=" + data.resW4326 +
                        "&resH4326=" + data.resH4326 +
                        "&x4326=" + data.x4326 +
                        "&y4326=" + data.y4326 +
                        "&x14326=" + data.x14326 +
                        "&y14326=" + data.y14326 +
                        "&entitatUid=" + mapConfig.entitatUid + 
                        "&businessId=" + mapConfig.businessId;
                    descarregaCaptura(urlIMG, 'mapa_geo.tiff');
                } else {
                    errorCaptura();
                }
                dfd.resolve(urlIMG);
            }, function(err) {
                dfd.reject(err);
            });
            break;
        case CAPTURA_INFORME:
            captureMap(parseInt(w / 1.2), parseInt(h / 1.2)).then(function(results){
                var urlIMG = "";
                if (results.status == "OK") {
                    urlIMG = createUrlIMG(results.UUID) + "&request=getCaptura";
                    jQuery('#img_canvas').attr('src', urlIMG);
                    comportamentCaptura(2);
                    if (isEuroregioUser()){
                        window.open("/print_euroregio.html", "Imprimir", "resizable=yes,status=yes,toolbar=yes,menubar=yes,location=no,scrollbars=yes")
                    }
                    else {
                        window.open("/print.html", "Imprimir", "resizable=yes,status=yes,toolbar=yes,menubar=yes,location=no,scrollbars=yes")
                    }
                  
                } else {
                    errorCaptura();
                }
                dfd.resolve(urlIMG);
            }, function(err) {
                dfd.reject(err);
            });
            break;
        case CAPTURA_GEOPDF:
            captureMap(w, h).then(function(results){
                if (results.status == "OK") {
                    var WF = calculaWF();
                    var data = getCapesVectorActives();
                   // var objLLegenda = capturaLlegenda(false);
                    data.imgW = WF.imgW;
                    data.imgH = WF.imgH;
                    data.resW = WF.resW;
                    data.resH = WF.resH;
                    data.resW = WF.resW;
                    data.resH = WF.resH;
                    data.resW4326 = WF.resW4326;
                    data.resH4326 = WF.resH4326;
                    data.x = WF.x;
                    data.y = WF.y;
                    data.x1 = WF.x1;
                    data.y1 = WF.y1;
                    data.x4326 = WF.x4326;
                    data.y4326 = WF.y4326;
                    data.x14326 = WF.x14326;
                    data.y14326 = WF.y14326;
                    data.request = "createGeoPDF";
                    data.uuid = results.UUID;
                    data.entitatUid = mapConfig.entitatUid;
                    data.businessId = mapConfig.businessId;
                    data.nomAplicacio = mapConfig.nomAplicacio;
                   // data.llegenda = objLLegenda;
                    createGeoPdfMap(data).then(function (geopdfresults) {
                        var urlIMG = "" ;
                        if (geopdfresults.status == "OK") {
                            urlIMG = createUrlIMG(results.UUID) + "&request=getGeoPDF";
                            descarregaCaptura(urlIMG, 'mapa_geoPDF.pdf');
                        } else {
                            errorCaptura();
                        }
                        dfd.resolve(urlIMG);
                    });
                } else {
                    errorCaptura();
                }
            }, function(err) {
                dfd.reject(err);
            });
            break;
		case CAPTURA_GALERIA:
			var invAspectRatio = h/w;
			var newWidth = 374; // Max image width in the gallery
			var newHeight = Math.round(374 * invAspectRatio);
            captureMap(w, h, newWidth, newHeight).then(function(results){
                var urlIMG = "";
                if (results.status == "OK") {
                    urlIMG = createUrlIMG(results.UUID) + "&request=getGaleria&update=true&businessid=" + mapConfig.businessId;
                    var img = document.createElement('img');
                    img.src = urlIMG;
                } else {
                    errorCaptura();
                }
                dfd.resolve(urlIMG);
            }, function(err) {
                dfd.reject(err);
            });
            break;
    }
    return dfd.promise();
}

function captureMap(w, h, nW, nH){
    var dfd = $.Deferred();

    var captureFunction;
    if (estatMapa3D) {
        captureFunction = captureCesiumMap;
    }else{
        captureFunction = captureLeafletMap;
    }
    captureFunction(w,h, nW, nH).then(function(url){
        var imgData = JSON.stringify(url.replace(/^data:image\/(png|jpeg);base64,/, ""));
        uploadImageBase64(imgData).then(function (results) {
            if (estatMapa3D) {
                mapaEstatNOPublicacio = true;
            }
            imatgeCarregada();
            dfd.resolve(results);
        });
    }, function(err) {
        dfd.reject(err);
    });

    return dfd.promise();
}

function captureLeafletMap(w, h, nW, nH){
    var dfd = $.Deferred();
    var divActiuCanvas = 'map';
    var options = {
        filter: function(node){
            return !node.classList || !node.classList.contains("leaflet-control");
        },
        width: w,
		height: h,
		destWidth: nW || w,
		destHeight: nH || h,
		quality: 0.9,
        proxy: paramUrl.nodeProxy,
        noProxy: ["server.arcgisonline.com"],
        imagePlaceholder: "/static/img/FFFFFF-0.png"
    }
    captureImage(divActiuCanvas, options).then(function(url){
        dfd.resolve(url);
    }, function(err) {
        dfd.reject(err);
    });
    return dfd.promise();
}

function captureCesiumMap(w,h){
    var dfd = $.Deferred();
    var divActiuCanvas = 'cesium-viewer';
    var disparaEventMapa = false;
    var mapaEstatNOPublicacio = false;
    var options = null;
    captureImage(divActiuCanvas, options).then(function(url){
        dfd.resolve(url);
    }, function(err) {
        dfd.reject(err);
    });
    return dfd.promise();
}

function captureImage(id_element, options){
    var dfd = $.Deferred();
    var element; 
    if(!_.isElement(id_element)){
        element = document.getElementById(id_element);
    }else{
        element = id_element;
    }

    domtoimage.toJpeg(element, options).then(function (dataUrl) {
        dfd.resolve(dataUrl);
    }).catch(function (error) {
        dfd.reject(error);
    });
    return dfd.promise();
}

function captureGEOPackage(mapConfig) {
    var dfd = $.Deferred();
    var data = getCapesVectorActives();

    if (matriuCapesLL.layers.length >= 1) {

        data.request = "createGeoPackage";
        data.entitatUid = mapConfig.entitatUid;
        data.businessId = mapConfig.businessId;
        data.nomAplicacio = mapConfig.nomAplicacio;

        createGeoPdfMap(data).then(
            function (geopackageresult) {
                var urlIMG = "";
                if (geopackageresult.status == "OK") {
                    urlIMG = createUrlIMG(geopackageresult.UUID) + "&request=getGeoPackage";
                    descarregaCaptura(urlIMG, 'map_gpkg_3857.gpkg');
                } else {
                    errorCaptura();
                }
                dfd.resolve(urlIMG);
            });

    } else {
        $('#dialog_error_upload_txt').html("");
        $('#dialog_error_upload_txt').text(window.lang.translate("Aquest mapa no té capes vector. No es pot genera GeoPackage"));
        $('#dialog_error_upload').modal('show');
        dfd.resolve();
    }

    return dfd.promise();

}

function pucPassar(item) {
    var passo = false;

    var _layer = null;
    if (item.layer) _layer = item.layer;
    else _layer = item; 
    var _options = "";
    if (_layer.options.businessId){
        _options = _layer.options;
    }
    else{
        _options = _layer.properties;
    }
    var isCapaActiva = false;
    try{
        if (_options!==undefined && document.getElementById('input-' + _options.businessId) != null) {
            if (document.getElementById('input-' + _options.businessId).checked) {
                isCapaActiva = true;
            }
        }
        else if (item.activa){
            isCapaActiva = item.activa;
        }
    }
    catch(e){
        isCapaActiva = false;
    }
   

    if (isCapaActiva) {
        if (_layer._map != null && _options.tipus != t_wms &&
            _options!==undefined && 
            _options.tipus != t_wms &&
            _options.tipus != t_heatmap &&
            _options.tipus != t_cluster &&
            _options.tipus != t_size) {
            passo = true;
            try {
                _layer.toGeoJSONcustom();
                passo = true;
            } catch (err) {
                passo = false;
                return passo;
            }

        }
    } else {
        passo = false;
    }
    
    return passo;
}

function ompleCapesMatriu(item) {
    var mainColor = "#FF0000";

    if (pucPassar(item)) {
        var _layer = null;
        if (item.layer) _layer = item.layer;
        else _layer = item;
        var L_JSON = _layer.toGeoJSONcustom();
        jQuery.each(L_JSON.features, function (i, feature) {

            var tipus = feature.geometry.type;
            if (tipus.indexOf("Point") != -1) {
            	 var _r = 6;
                if (!feature.styles.icon) {
              
                    if (feature.styles && feature.styles.radius) {
                        _r = feature.styles.radius;
                    }

                    if (_r <= 6) {
                        feature.properties.OGR = "PEN(c:" + feature.styles.color + ",w:6px,s:" + _r + "px);BRUSH(fc:" + feature.styles.fillColor + ",s:" + _r + "px)";
                    } else {
                        feature.properties.OGR = "SYMBOL(o:" + feature.styles.color + ",w:6px,s:" + parseInt(_r * 1.8) + "px,c:" + feature.styles.fillColor + ");";
                    }
                    mainColor = feature.styles.fillColor;
                } else {
                    var icona;
                    if (feature.styles.icon.options.markerColor) {
                    	var _pr=feature.styles.icon.options.markerColor;
                    
                    	if(_pr.indexOf('punt_r')!=-1){
                  		
                    		 if (_r <= 6) {
                                 feature.properties.OGR = "PEN(c:" + feature.styles.icon.options.color + ",w:6px,s:" + _r + "px);BRUSH(fc:" + feature.styles.icon.options.fillColor + ",s:" + _r + "px)";
                             } else {
                                 feature.properties.OGR = "SYMBOL(o:" + feature.styles.icon.options.color  + ",w:6px,s:" + parseInt(_r * 1.8) + "px,c:" + feature.styles.icon.options.fillColor + ");";
                             }
                             mainColor = feature.styles.icon.options.fillColor;	
                   	
                    	}else{
                    	
                        icona = "/opt/geocat/maps/galeria/" + feature.styles.icon.options.markerColor;
                        mainColor = icona;
                        feature.properties.OGR = "SYMBOL(c:#ff0000,id:" + icona + ".png)";
                        
                    	}
                    } else {
                        var ff = feature.styles.icon.options.iconUrl
                        icona = "/opt/geocat/maps/galeria/" + ff.substring(ff.lastIndexOf("/") + 1, ff.lastIndexOf("."));
                        mainColor = icona;
                        feature.properties.OGR = "SYMBOL(c:#ff0000,id:" + icona + ".png)";
                    }
                   
                }
            } else if (tipus.indexOf("Line") != -1) { //Polyline
                feature.properties.OGR = "PEN(c:" + feature.styles.color + ",w:" + (parseInt(feature.styles.weight) + 3) + "px)";
                mainColor = feature.styles.color;
            } else if (tipus.indexOf("Polygon") != -1) {
                mainColor = feature.styles.fillColor;
                if (!mainColor || mainColor.indexOf("rgba") != -1) {
                    mainColor = feature.styles.color + "90 ";
                }
                feature.properties.OGR = "PEN(c:" + feature.styles.color + ",w:" + (parseInt(feature.styles.weight) + 3) + "px);BRUSH(fc:" + mainColor + ")";
            } else {
                feature.properties.OGR = "PEN(c:#0000ff,w:5px);BRUSH(fc:#0000ff90)";
            }
        });
        try {
            matriuCapesLL.layers.push(JSON.stringify(L_JSON));
        } catch (Err) {
            var cache = [];
            matriuCapesLL.layers.push(JSON.stringify(L_JSON, function (key, value) {
                if (typeof value === 'object' && value !== null) {
                    if (cache.indexOf(value) !== -1) {
                        // Circular reference found, discard key
                        return;
                    }
                    // Store value in our collection
                    cache.push(value);
                }
                return value;
            }));
            cache = null;
        }
        matriuCapesLL.n_layers.push((item.name ? item.name : item.layer.options.nom));
        matriuCapesLL.id_layers.push(_layer.options.businessId);

        var geoM = _layer.options.geometryType ? _layer.options.geometryType : t_marker;
        matriuCapesLL.t_layers.push(geoM);
        matriuCapesLL.c_layers.push(mainColor);

        try {
            matriuCapesLL.e_layers.push(_layer.getBounds().toBBoxString());
            matriuCapesLL.extent = map.getBounds().toBBoxString();
        } catch (err) {
            matriuCapesLL.e_layers.push("1,39,3,43");
        }

    }
}

function getCapesVectorActives() {
    matriuCapesLL.layers = [];
    matriuCapesLL.n_layers = [];
    matriuCapesLL.id_layers = [];
    matriuCapesLL.t_layers = [];
    matriuCapesLL.c_layers = [];

    var _layers = null;

    if(controlCapes){
        _layers = controlCapes._layers;
        jQuery.each(_layers, function (i, item) {
            ompleCapesMatriu(item);
    
            jQuery.each(item._layers, function (j, item2) {
                ompleCapesMatriu(item2);
            });
        });
    }else{
        if (window.anf.default.instamapsVisorApp.$children[0]) {
            var viewer = getInstamapsMapViewer();
            _layers = viewer.layersLeaflet;
            jQuery.each(_layers, function (i, item) {
                ompleCapesMatriu(item);
            });
        }
    }

    return matriuCapesLL;
}

function calculaWF() {
    var d = map.getSize();
    w = d.x;
    h = d.y;
    var topMap = jQuery('#map').position().top;
    var puntIn = map.getBounds().getNorthWest();
    var NW = L.CRS.EPSG3857.project(puntIn);
    var SE = L.CRS.EPSG3857.project(map.getBounds().getSouthEast());
    var ff_Pixels = new L.Point(0, 0);
    var ff_MM = map.layerPointToLatLng(ff_Pixels);
    var ff_3557 = L.CRS.EPSG3857.project(ff_MM);
    var pNW_Pixels = new L.Point(0, -topMap);
    var pNW = map.layerPointToLatLng(pNW_Pixels);
    var FACT = parseFloat(ff_MM.lat) - parseFloat(pNW.lat);
    var pNW_3557 = L.CRS.EPSG3857.project(pNW);
    var FACT = parseFloat(ff_3557.y) - parseFloat(pNW_3557.y);
    var _FACT = parseFloat(ff_MM.lat) - parseFloat(pNW.lat);
    var pNE_Pixels = new L.Point(w, h - topMap);
    var pNE = map.layerPointToLatLng(pNE_Pixels);
    var pNE_3557 = L.CRS.EPSG3857.project(pNE);
    var mapW = (pNE_3557.x - pNW_3557.x) / w;
    var mapH = (pNW_3557.y - pNE_3557.y) / h;
    var nouY = parseFloat(parseFloat(NW.y) - (parseFloat(FACT)));
    var _nouY = parseFloat(parseFloat(puntIn.lat) - (parseFloat(_FACT)));
    var _nouYMIN = parseFloat(parseFloat(puntIn.lat) + (parseFloat(_FACT)));
    var mapW4326 = (pNE.lng - pNW.lng) / w;
    var mapH4326 = (pNW.lat - pNE.lat) / h;
    var WF = {};
    WF.imgW = w;
    WF.imgH = h;
    WF.resW4326 = mapW4326;
    WF.resH4326 = mapH4326;
    WF.resW = mapW;
    WF.resH = mapH;
    WF.x1 = SE.x;
    WF.y1 = nouY
    WF.x = NW.x;
    WF.y = SE.y;
    WF.x4326 = map.getBounds().getNorthWest().lng;
    WF.y14326 = _nouY;
    WF.x14326 = map.getBounds().getSouthEast().lng;
    WF.y4326 = map.getBounds().getSouthEast().lat;

    return WF;
}

function checkDataVectorlayers(msg) {

    var data = getCapesVectorActives();

    if (data.layers.length == 0) {

        if (!msg) {
            msg = 'un vector GeoPackage';
        } else {
            msg = msg;
        }

        if ($('#dialog_error_upload_txt').length) {
            $('#dialog_error_upload_txt').html("");
            $('#dialog_error_upload_txt').text(window.lang.translate("Aquest mapa no té capes vector. No es pot generar ") + msg);
            $('#dialog_error_upload').modal('show');

        } else {
            alert(window.lang.translate("Aquest mapa no té capes vector. No es pot generar ") + msg);

        }
        return false;
    } else {
        return true;
    }

}

function capturaLlegenda() {
    var legendContent = $("#legend > ul")[0];

    var widthOrigin = $(legendContent).css("width");

    prepareLegendToCapture(legendContent, widthOrigin).then(function(){
        var width = legendContent.scrollWidth;
        var height = legendContent.scrollHeight;
        var deltaH = 3;
        height = height + deltaH;
        width = width + deltaH;
        var options = {
            filter: function(node){
                return !node.classList || !node.classList.contains("material-icons");
            },
            width: width,
            height: height,
            style: {
                "-webkit-animation": "none",
                "animation": "none",
                "max-height": height + "px",
                "width": width + "px",
                "height": height + "px",
                "border": "1px solid #999999",
                "background-color": "#FFFFFF"
            },
            proxy: paramUrl.nodeProxy,
            imagePlaceholder: "/static/img/FFFFFF-0.png"
        }
        captureImage(legendContent, options).then(function(dataUrl){
            restoreLegendAfterCapture(legendContent, widthOrigin);
            var link = document.createElement('a');
            link.download = "exportedLegend.png";
            link.href = dataUrl;
            link.click();
        }, function(err) {
            errorCaptura();
        });

    });

}

function prepareLegendToCapture(legendElement, widthOrigin){
    var dfd = $.Deferred();
    var maxWidth = 0;
    var deltaH = 0;

    $(legendElement).find(".legend-symbol-name").each(function(){
        var width = this.scrollWidth;
        if(width > maxWidth) {
            maxWidth = width;
        }
    });
    if (maxWidth < parseInt(widthOrigin)){
        maxWidth = parseInt(widthOrigin);
    }
    maxWidth = maxWidth + deltaH;

    $(legendElement).css({
        "width": maxWidth + "px"
    });
    
    $(legendElement).find(".truncate").each(function(){
        $(this).css({
           "overflow": "none"
        });
    });

    $(legendElement).find("ul").each(function(){
        var height = this.scrollHeight;
        $(this).css({
            "-webkit-animation": "none",
            "animation": "none",
            "max-height": height + "px",
            "max-width": maxWidth + "px"
        });
    });
    dfd.resolve();
    return dfd.promise();
}

function restoreLegendAfterCapture(legendElement, widthOrigin){
    var dfd = $.Deferred();

    $(legendElement).css({
        "width": widthOrigin
    });

    $(legendElement).find(".truncate").each(function(){
        $(this).css({
           "overflow": "hidden"
        });
    });

    $(legendElement).find("ul").each(function(){
        $(this).css({
            "-webkit-animation": "expandWrapper 1s both ease",
            "animation": "expandWrapper 1s both ease",
            "max-height": "60vh",
            "max-width": ""
        });
    });
    dfd.resolve();
    return dfd.promise();
}

function imatgeCarregada() {
    ActDesPrintMode(false);
}

function ActDesPrintMode(printMode) {
    try {
        map.changeBackgroundType(map.options.typeMap, printMode);
        return true;
    } catch (err) {
        return true;
    }
}

function calculaDistanciaMetres(PuntIn, PuntFi) {
    var lat1 = PuntIn.lat;
    var lon1 = PuntIn.lng;
    var lat2 = PuntFi.lat;
    var lon2 = PuntFi.lng;

    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
}

function deg2rad(deg) {
    return deg * (Math.PI / 180)
}

function rag2deg(deg) {
    return deg * (180 / Math.PI)
}

function capturaWMSMAP(idMapa, businessId, nomAplicacio, idUsuari) {
    var dfd = $.Deferred();
    var _idMapa = idMapa;
    var _businessId = businessId;
    var _UrLFake="https://betaserver.icgc.cat/geoservice/183381603914615401780745328646983276905";
    var _layerFake="fake2";

    try {

        if (map.miraBBContains(map.getBounds()) == 0) {
            if ($('#dialog_error_upload_txt').length) {
                $('#dialog_error_upload_txt').html("");
                $('#dialog_error_upload_txt').text(window.lang.translate("Servei disponible dins el territori de Catalunya"));
                $('#dialog_error_upload').modal('show');
            } else {
                alert(window.lang.translate("Servei disponible dins el territori de Catalunya"));
            }


        } else if (InstamapsUtils.Validator.isModeMapa($(location).attr('href'))) {

            var data = getCapesVectorActives();

            if (data.layers.length > 0) {
                data.request = "createWMSfromMap";
                data.entitatUid = _UsrID,
                data.businessId = businessId;
                data.nomAplicacio = nomAplicacio;
                data.modeMapa = InstamapsUtils.Validator.isModeMapa($(location).attr('href'));

                createMapToWMS(data).then(

                    function (results) {

                        if (results.status == "OK") {
                            showImpresssioModal(results.url, _UsrID)
                        }

                    });
            } else {
                var _wmsURL = "";
                
                showImpresssioModal(_UrLFake,_layerFake);
            }

        } else {
            var data = getCapesVectorActives();

            if (data.layers.length > 0) {
                if (_idMapa === undefined || _idMapa === null) _idMapa = visor._mapConfig.options.idusr;
                if (_businessId === undefined || _businessId === null) _businessId = visor._mapConfig.businessId;
                var _wmsURL = WMS_APP + "geoservicelocal/" + idUsuari + "/" + _businessId;
                var _newBBOX = dealBBOX(map.getBounds());
                var _urlIS = externalImpressio + "?url=" + encodeURI(_wmsURL) + "&layer=MAPA_" + idUsuari + "&bbox=" + _newBBOX;
                dfd.resolve(_urlIS);
            }else{
                var _newBBOX = dealBBOX(map.getBounds());
                var _urlIS = externalImpressio + "?url=" + encodeURI(_UrLFake) + "&layer=MAPA_" + _layerFake + "&bbox=" + _newBBOX;
                dfd.resolve(_urlIS);
            }
        }
    } catch (err) {

        console.info(err);
    }
    return dfd.promise();
}

function dealBBOX(bboxObj) {

    var x0 = bboxObj._southWest.lng;
    var y0 = bboxObj._southWest.lat;
    var x1 = bboxObj._northEast.lng;
    var y1 = bboxObj._northEast.lat;

    var _bboxString = bboxObj.toBBoxString()

    if ((x0 < 0.1087) && (y0 < 40.4763) && (x1 > 3.33669) && (y1 > 42.8855)) { // 42.3748

        var factorExtraX = 0.05;

        if (InstamapsUtils.Validator.isModeMapa($(location).attr('href'))) {
            factorExtraX = 0.1;
        }

        _bboxString = CatBounds.toBBoxString();
    }

    return _bboxString;
}

function showImpresssioModal(url, mapaUId) {

    var _newBBOX = dealBBOX(map.getBounds());
    var _urlIS = externalImpressio + "?url=" + encodeURI(url) + "&layer=MAPA_" + mapaUId + "&bbox=" + _newBBOX;
    var $desc_img = jQuery('#dialog_captura').find('.desc_img');

    comportamentCaptura(4, 'Genera imatges per imprimir',
    "<span lang='ca'>Accedeix a aquesta eina per generar imatges imprimibles a escala</span>"+
    "  <span><a target='_blank' href='https://betaportal.icgc.cat/wordpress/faq-dinstamaps/#escala'><i class='glyphicon glyphicon-info-sign'></i></a></span>");

    $desc_img.prop('href', _urlIS);
    $desc_img.prop('target', '_blank');
    $desc_img.prop('type', 'text/html');
    $desc_img.prop('download', false);
    jQuery('.desc_img').removeProp('download');
    $desc_img.removeProp('download');
    $desc_img.removeAttr('download');

    $('#dialog_captura').find('.bt_desc_img').show();

}
